
// import { create } from 'mobx-persist';
// const hydrate = create({
//   storage: localStorage,
//   jsonify: true
// });

import { CustDiagStore } from "./CustDiagStore";

export class RootStore {
  custdiagStore: CustDiagStore;

  constructor() {
    this.custdiagStore = new CustDiagStore(this);

    // hydrate('user', this.UserStore).then(() => {
    //   console.log('Dev Monster Rehydrated ');
    // });
  }
}
